import { z } from "zod";

export const faqItemSchema = z.object({
  id: z.uuid(),
  category: z.string(),
  question: z.string(),
  response: z.string(),
  status: z.string(),
  updated_at: z.string(),
  user: z.any(),
});
